import { Component, OnInit } from '@angular/core';
import { PurchaseOrderDto, PurchaseOrderSubscriberModel } from '@app/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';

@Component({
  selector: 'ngx-subscriber-list-modal',
  templateUrl: './subscriber-list-modal.component.html',
  styleUrls: ['./subscriber-list-modal.component.scss'],
})
export class SubscriberListModalComponent implements OnInit {
  purchaseOrder: PurchaseOrderDto;
  subscribers: PurchaseOrderSubscriberModel[] = [];
  isRCDSS = environment.name === 'rcdss';

  constructor(public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
